/*

Show available streams to broadcast and creates Broadcasts

*/
import Carousel from "./Carousel";
import StreamButton from "./StreamButton";
import "../style.css";
import AddSource from "./AddSource";

const MediaCarousel = (props) => {
  let slides = [];
  slides.push(
    <div
      className="container"
      style={{
        height: "100%",
        overflowY: "auto",
      }}
    >
      <AddSource addMediaStream={props.addMediaStream} />
    </div>
  );
  if (props.mediaStreams) {
    props.mediaStreams.map((stream, i) => {
      let isBroadcasting = false;
      for (const activeStream of props.activePushes) {
        if (
          stream?.mediaSourceRef?.current ==
          activeStream?.mediaSourceRef?.current
        ) {
          isBroadcasting = true;
        }
      }
      slides.push(
        <StreamButton
          isPreview={stream == props.currentStream}
          mediaIndex={i}
          mediaStreams={props.mediaStreams}
          streamObj={stream}
          // Setters for the state
          setCurrentSteam={props.setCurrentSteam}
          removeStream={props.removeStream}
          clearPreview={props.clearPreview}
          startBroadcast={props.startBroadcast}
          removeBroadcast={props.removeBroadcast}
          // Disable the broadcast buttons when needed
          isAtLimit={props.isAtLimit}
          isBroadcasting={isBroadcasting}
        />
      );
    });
  }

  return <Carousel slides={slides} carouselItems={props.carouselItems} />;
};

export default MediaCarousel;
